import { Component, OnInit, ViewChild, Output, EventEmitter, Input, ChangeDetectorRef, SimpleChanges, ViewChildren, QueryList } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog, MatSnackBar, MatTableDataSource, MatPaginator, MatSort, MatSidenav } from '@angular/material';
import { AddCompModalComponent } from '../add-comp-modal/add-comp-modal.component';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CompetenciesService } from 'src/app/services/competencies.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import { config } from '../../_models/userCompetency'
import * as _ from 'lodash';
import { SharedService } from 'src/app/shared.service';
import { FilterService } from '../../services/filter.service'
import { UtilityService } from '../../services/utility.service'
import { AssetService } from '../../services/asset.service'
import { StaffService } from '../../services/staff/staff.service';
import { CompetencyDetailModalComponent } from '../competency-detail-modal/competency-detail-modal.component';

@Component({
  selector: 'app-competency-list',
  templateUrl: './competency-list.component.html',
  styleUrls: ['./competency-list.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ]),
  ],
})
export class CompetencyListComponent implements OnInit {
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort;
  displayedColumns = ['select', 'alias', 'title', 'achievementDate', 'recertificationDate', 'assessmentDate', 'status', 'action']
  pageSizeOptions: number[] = [25, 50, 100];
  compArray: any = [];
  compCopy: any = [];
  instructorId;
  expandedElement;
  allFiles: any;
  file: any;
  currentUser: any;
  hideActions: boolean;
  currentInnerIndex: any;
  currentOuterIndex: any = -1;
  jobs;
  displayCompentency
  systemDate
  searchText
  isView = false
  // filterActive;
  noDataMsg = {
    title: "No Competencies!",
    data: "You have not yet added any competencies"
  }
  noDataMsgUser = {
    title: "No Users!",
    data: "You have not yet allocated competency to user"
  }
  filterActive: boolean = false
  afterFilter
  tempDataSource: any;
  // category = config.list
  category
  selectedCat: any;
  loading: boolean = false;
  viewDelete: boolean = false;
  noFiles = {
    title: "No Files!",
    data: "No files added yet!"
  }
  competencyModule: boolean = false
  staffData = []
  compArrayCopy: any = []
  isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('expandedDetail');
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  @ViewChild('sidenav', { static: false }) public mydsidenav: MatSidenav;
  @ViewChildren('myCheckbox') private myCheckboxes: QueryList<any>;

  @Input('displayCompentencies') displayCompentencies;
  @Input('deletedId') deletedId;
  @Input('newComp') newCompAdded: any;
  @Input('isDetailsModel') isDetailsModel: Boolean
  @Input('competenciesData') competenciesData
  @Input('systemDate') systemDateModel
  @Input('userList') userList
  @Input('categoryList') categories
  @Input('isView') displayCom
  @Input('staffDetails') userDetails
  @Input('isDownload') isDisplay: Boolean
  user = JSON.parse(localStorage.getItem('userRoles'))
  isDisabled = false
  isViewButton = false
  @Output() openSideNav: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  @Output() addCompetencyToMultiple: EventEmitter<any> = new EventEmitter<any>();

  multipleCompetency = []
  staffUserDetails
  constructor(
    public _filter: FilterService,
    public dialog: MatDialog,
    private _cd: ChangeDetectorRef,
    public _snackBar: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    public _competencyService: CompetenciesService,
    private _sharedService: SharedService,
    public _utilityService: UtilityService,
    public _assetService: AssetService,
    private router: Router,
    public _staffService: StaffService,
  ) {

    this.dataSource = new MatTableDataSource(this.compArray)
  }

  ngOnInit() {

    console.log("USER ROLE", this.user)
    this.activatedRoute.params.subscribe(params => {
      this.instructorId = params['id'];
      console.log("this.instructorId =  ", this.instructorId);
      if (this.instructorId) {
        this.getCompetencyData()
        this.getCompetencyList().then((data) => {
          console.log("DATA WHILE COMPETENCY FROM USER", data)
        })
      }
    });



    // if(!this.isView && this.instructorId == undefined) this.getCompetencyList()
    // }
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("***changes", changes);
    if (changes.displayCompentencies && changes.displayCompentencies.currentValue) {
      this.displayCompentency = changes.displayCompentencies.currentValue;
    }
    if (changes.deletedId && changes.deletedId.currentValue) {
      this.loading = true
      this.deletedId = changes.deletedId.currentValue
      let tempdeletedId = this.deletedId
      console.log("*****this.deletedId", this.deletedId);
      let compIndex = _.findIndex(this.compArray, function (o) { return o._id == tempdeletedId.competenciesId })
      if (compIndex > -1) {
        let fileIndex = _.findIndex(this.compArray[compIndex].files, function (o) { return o._id == tempdeletedId.fileId })
        if (fileIndex > -1) {
          this.compArray[compIndex].files.splice(fileIndex, 1)
          this.updateData(this.compArray)
        }
      }
    }

    if (changes.competenciesData && changes.competenciesData.currentValue) {
      console.log("here is the data comp ", changes.competenciesData.currentValue)
      this.compArray = changes.competenciesData.currentValue
      // //  this.compArray = res.competencies
      this.isView = true
      this.updateData(this.compArray)
      //  this.isDetailsModel=true
      this.loading = false


    }
    if (changes.userList && changes.userList.currentValue) {
      this.displayedColumns = ['name', 'achievementDate', 'recertificationDate', 'assessmentDate', 'status', 'action']
    }


    if (changes.systemDateModel && changes.systemDateModel.currentValue) {
      console.log("here is the data comp Date", changes.systemDateModel.currentValue)
      this.systemDate = changes.systemDateModel.currentValue
      // //  this.compArray = res.competencies
      // this.updateData(this.compArray)
      //  this.isDetailsModel=true
      this.loading = false


    }

    if (changes.displayCom && changes.displayCom.currentValue) {
      // if (this.router.url.includes('/competency')) {
      this.displayedColumns = ['alias', 'title', 'action'];
      this.getCompetencyList().then((data) => {
        console.log("DATA OF COMEPTENCY CATEGORY", data);
        this.category.map(ele => {
          if (ele.value) ele.value.map(e => {
            this.compArray.push({ ...e, title: e.name, category: ele.viewValue })
          })
        })
        this.updateData(this.compArray)
        // this.dataSource = new MatTableDataSource(this.compArray)
      })
      this.competencyModule = true
      this._staffService.getAllStaff().subscribe((res) => {
        res.data.instructors.filter((a) => {
          console.log("WHAT IS THE VALUE OF STAFF", a)
          if (a.isArchive === false) this.staffData.push(a)
        })
        console.log("STAFF USER DATA", this.staffData);
        // this.staffData = res.data.instructors
      })
      // }
      this.dataSource = new MatTableDataSource(this.compArray)
    }


    if (changes.categories && changes.categories.currentValue) this.category = changes.categories.currentValue

    if (changes.userDetails && changes.userDetails.currentValue) this.staffUserDetails = changes.userDetails.currentValue


    if (changes.isDisplay && changes.isDisplay.currentValue) this.isViewButton = changes.isDisplay.currentValue

    console.log("CURRENT USER DATA", this.staffUserDetails)

  }


  addCompModal(item?) {
    this._assetService.closeDisplayFile(true)
    this.closeFilesSideNav.emit('close')
    let data
    if (!this.competencyModule) {
      console.log("Open modal FOR STAFF USER");
      data = {
        instructorId: this.instructorId,
        categoryList: this.category
      }
    }
    else {
      data = {
        instructorId: this.instructorId,
        competencyModule: this.competencyModule,
        trainersList: this.staffData,
        competency: item,
        categoryList: this.category,
      }
    }


    console.log("THIS IS THE DATA TO BE SEND", data)

    this._utilityService.commonDialogBoxOpen(AddCompModalComponent, data, 900).afterClosed().subscribe(added => {
      console.log("Data in comp", added, this.competencyModule);
      if (added == undefined) return
      else {
        if (!this.competencyModule) {
          this.compArray = added.competencies
          this.systemDate = added.dateSystem
          // console.log("***this.compArray", this.compArray);
          this.compCopy = this.compArray;
          this.updateData(this.compArray)
        } else {
          console.log("CALL THIS ELSE PART OR NOT")
          this._staffService.getAllStaff().subscribe((res) => {
            console.log(res.data);
            this.staffData = res.data.instructors
            this._competencyService.newCompetencyAdded(this.staffData)
          })
          // this.addCompetencyToMultiple.emit('added')
        }
      }
    })
  }

  editCompetency(item) {
    this._assetService.closeDisplayFile(true)
    let data
    if (!this.competencyModule) {
      data = {
        instructorId: this.instructorId,
        competency: item,
        isEdit: true,
        categoryList: this.category
      }
    }
    else {
      data = {
        instructorId: item.instructorId,
        competencyModule: this.competencyModule,
        trainersList: this.staffData,
        competency: item,
        isEdit: true,
        categoryList: this.category
      }
    }
    this._utilityService.commonDialogBoxOpen(AddCompModalComponent, data, 900).afterClosed().subscribe(compData => {
      console.log("Data in comp", compData);
      if (compData == undefined) return
      else if (compData && compData.edit) {
        if (!this.competencyModule) {
          this.compArray = compData.edit.competencies
        } else {
          if (compData.edit.competencies && compData.edit.competencies.length)
            this.compArray.map((staff, i) => {
              compData.edit.competencies.map(res => {
                if (staff.instructor === res.instructor && staff._id === res._id) {
                  this.compArray[i] = { name: staff.name, instructorId: staff.instructor, ...res }
                }
              })
            });
        }
        this.systemDate = data.dateSystem
        this.compCopy = this.compArray;
        this.updateData(this.compArray)
      } else if (compData && compData.delete) {
        console.log("This is for delete competency", compData);
        if (!this.competencyModule) {
          this.compArray = compData.delete.competencies
          this.updateData(this.compArray)
        } else {
          console.log("COMpetency data", compData, this.compArray);
          const compIndex = this.compArray.findIndex((x) => x.instructorId === compData.instructorId)
          this.compArray.splice(compIndex, 1)
          console.log("What is the competency index", compIndex, this.compArray);
          this.updateData(this.compArray)
        }

      }
    })
  }
  openFileUpload(element, i) {
    console.log("element in file upload", element, i);
    this.openDialog(NewFileModalComponent, { competenciesId: element._id }).subscribe(uploaded => {
      console.log("uploaded", uploaded);
      let tempArray = this.compArray

      if (uploaded && uploaded[0] && uploaded[0].data) {
        let index = _.findIndex(tempArray, function (o) { return o._id == element._id })
        if (index > -1) {
          this.compArray[index].files.push(uploaded[0].data.file)
          this.updateData(this.compArray)
        }
      }
    })
  }

  updateData(comp) {
    console.log("UPDATING DATA  for competency= ", comp)
    let tempArray = []
    tempArray = comp
    this.dataSource = new MatTableDataSource(tempArray);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.loading = false;
  }
  openDialog(someComponent, data = {}): Observable<any> {
    console.log('OPENDIALOG', 'DATA = ', data)
    const dialogRef = this.dialog.open(someComponent, { data, width: '600', height: '967px' });

    return dialogRef.afterClosed();
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  expand(element) {
    console.log("***element", element)
    this.expandedElement = element
    this.allFiles = element.files
  }
  fileDetails(event) {
    console.log("event file tile clicked", event);
    console.log("this.expandedElement = element", this.expandedElement);
    this._assetService.displayFile(event)
  }

  delete(element, outerIndex, innerIndex) {
    console.log("element on delete", element);
    this.openDialog(DeleteConfirmModalComponent, element).subscribe(confirm => {
      if (confirm == 'no') return
      else {
        console.log("element on delete", element, outerIndex, innerIndex);
        this._competencyService.deleteCompetency(element.competenciesId).subscribe(res => {
          console.log("Competency deleted====>>>", res);
          this.compArray[outerIndex].competencies.splice(innerIndex, 1)
        })
      }
    })
  }
  deletedFile(event) {
    console.log("**********file deleted event in competencies", event)
  }

  filter(searchText) {
    this.afterFilter = null
    this.filterActive = false;
    console.log('FILTER CALLED', searchText);
    if (searchText === '') {
      this.updateData(this.compArrayCopy.length > 0 ? this.compArrayCopy : this.compArray);
      return;
    }
    console.log("filter Time pass data..", this.compArray)
    let data
    if (this.compArrayCopy.length > 0) data = this.compArrayCopy
    else data = this.compArray
    if (!this.userList) this.tempDataSource = this._filter.filter1(searchText, data, ['title', 'alias']);
    else this.tempDataSource = this._filter.filter1(searchText, data, ['name']);

    this.updateData(this.tempDataSource)
    // console.log("tempDataSource-->", this.tempDataSource, this.loading, this.filterActive);
    if (this.tempDataSource.length <= 0) {
      this.filterActive = true;
      if (!this.userList)
        this.afterFilter = {
          title: "No Competencies!",
          data: "Sorry, no competencies matched your search"
        }
      else
        this.afterFilter = {
          title: "No Users!",
          data: "Sorry, no users matched your search"
        }
    }
  }



  weekHighlights(item) {

    // console.log("here is the item data ===>",this.systemDate )
    let achievementDate = this.systemDate
    let expiryDate = new Date(item.expiryDate)
    const week = 7 * 24 * 60 * 60 * 1000;
    let weeks = Math.ceil((<any>this.startOfWeek(new Date(expiryDate)) - <any>this.startOfWeek(new Date(achievementDate))) / week)
    if (12 >= weeks) {
      return 'heightLight-text'
    }
    else {
      return 'normal'
    }
  }
  weekHighlightstr(item) {

    // console.log("here is the item data ===>",this.systemDate )
    let achievementDate = this.systemDate
    let expiryDate = new Date(item.expiryDate)
    const week = 7 * 24 * 60 * 60 * 1000;
    let weeks = Math.ceil((<any>this.startOfWeek(new Date(expiryDate)) - <any>this.startOfWeek(new Date(achievementDate))) / week)
    // console.log("here is number of weeks ==>",weeks)

    // if (item.category == 'others') {
    //   return 'normal'
    // }
    // else 
    if (12 >= weeks) {
      return 'heightLight-tr'
    }
    else {
      return 'normal'
    }


  }

  competencesStatusDisplay(data) {
    if (data.competenciesType && data.competenciesType.length && data.competenciesType[data.competenciesType.length - 1].status == 'P') {
      return data.competenciesType[data.competenciesType.length - 1].status
    }
    else {
      return ''
    }
  }

  statusValidation(data) {
    // if(data.competenciesType && (!data.competenciesType.length || data.competenciesType.length && data.competenciesType[data.competenciesType.length-1].status !='AP'  ) ){
    //   return 'd-none'
    //   }

  }

  startOfWeek(dt) {
    // console.log("here is the item extra function work===>")

    const day = 24 * 60 * 60 * 1000;
    const weekday = dt.getDay();
    return new Date(dt.getTime() - Math.abs(0 - weekday) * day);
  }

  selectCategory(event) {
    console.log("event when it is selected", event);

    let array1 = []
    let array2 = event.value
    console.log("this.selectedCat", this.selectedCat);

    if (array2 && array2.length) {
      array1 = this.compArray.filter(function (item) {
        return array2.includes(item.category);
      })
    }
    this.compArrayCopy = array1
    if (!array2.length) {
      this.updateData(this.compArray);
      this.compArrayCopy = this.compArray
      this.filterActive = false
      this.afterFilter = null
      return;
    }

    console.log('selected type for filter.................', array1)
    if (array1.length <= 0) {
      this.filterActive = true
      this.afterFilter = {
        title: "No Competencies!",
        data: "Sorry, no competencies matched your selected category"
      }
    } else {
      this.filterActive = false
      this.afterFilter = null
    }
    this.updateData(array1)

  }


  selectCompetency(event, item) {
    if (event.checked) this.multipleCompetency.push({ _id: item._id, title: item.title, expiryDate: item.recertificationDate })
    else {
      this.multipleCompetency.splice(this.multipleCompetency.findIndex(a => a._id === item._id), 1)
    }
    console.log("SELECTED MULTIPLE COMPETENCY LIST", this.multipleCompetency)
  }

  // API

  /**
   * Store Multiple selected competency for single operative user
   */
  addMultipleCompetencies() {
    console.log("ALL COMPETENCY LIST", this.multipleCompetency)
    console.log("CURRENT INSTRUCTOR ID", this.instructorId)
    this.isDisabled = true
    let obj = {
      staffId: this.instructorId,
      selectedCompetencies: this.multipleCompetency
    }
    this._staffService.addMultipleCompetencies(obj).subscribe((data) => {
      console.log("DATA ADDED FOR SELECTED COMPETENCY", data)
      this._utilityService.handleSnackBar({ msg: 'Competency List Updated Successfully', button: 'OK' })
      this.isDisabled = false
    }, error => {
      console.log("ERROR WHILE ADD MULTIPLE COMPETENCY", error)
      this._utilityService.handleSnackBar({ msg: error.msg, button: 'OK' })
      this.isDisabled = false
    })
  }

  manageCheckList() {
    let myCheckboxes = this.myCheckboxes.toArray();
    console.log("mycheckboxeslist==========>", myCheckboxes)
    let len = myCheckboxes.length;
    for (let i = 0; i < len; i++) {
      myCheckboxes[i].checked = false;
      console.log("my checked value=======>", myCheckboxes[i].checked)
    }
    // this.multipleJobsDelete = []
  }

  getCompetencyData() {
    console.log('getCompetencyData Calling');
    this._competencyService.getCompetencies(this.instructorId).subscribe(res => {
      console.log("***res in comp = ", res.competencies, this.staffUserDetails);
      this.compArray = res.competencies
      this.systemDate = res.dateSystem
      if (this.user && this.user.isAdmin) this.multipleCompetency = this.staffUserDetails && this.staffUserDetails.selectedCompetencies && this.staffUserDetails.selectedCompetencies.length ? this.staffUserDetails.selectedCompetencies : []
      console.log("***this.compArray", this.compArray);
      this.compCopy = this.compArray;
      this.updateData(this.compArray)
      this.loading = false;
    })
  }

  compDetails(data, outerIndex, innerIndex) {
    if (this.competencyModule) {
      console.log('Comp Details====>', data, outerIndex, innerIndex);
      let userList = []
      this.staffData.length && this.staffData.map(staff => {
        staff.competencies.map(com => {
          if (com.title == data.title) {
            userList.filter((user, i) => { if (user.name == staff.name) userList.splice(i, 1) })
            userList.push({ name: staff.name, instructorId: staff._id, ...com })
          }
        })
      })
      let compData = {
        competencies: userList,
        systemDate: this.systemDate,
        userList: true,
        categoryList: this.category
      }
      this._utilityService.commonDialogBoxOpen(CompetencyDetailModalComponent, compData)
        .afterClosed().subscribe((compData) => {
          console.log("THIS IS THE COMPDATA", compData)
          this._staffService.getAllStaff().subscribe((res) => {
            console.log(res.data);
            this.staffData = res.data.instructors
          })
        })
    }
    else {
      this.currentOuterIndex = outerIndex;
      this.currentInnerIndex = innerIndex
      data['isCompetencies'] = true;
      data['instructorId'] = this.instructorId;
      this.openSideNav.emit({ competency: data, compIndex: this.currentOuterIndex })
    }
  }

  newComp() {
    console.log("New comp clicked");

    this.currentOuterIndex = -1;
    let data = {
      title: '',
      category: '',
      expiryDate: '',
      achievementDate: '',
      trainingBook: '',
      bookedDate: '',
      bookedBy: '',
      isCompetencies: true,
      files: [],
      instructorId: this.instructorId
    }
    this.openSideNav.emit({ competency: data })
    console.log("event emitted with data", data);
  }

  catChanged(event) {

    console.log('Category Changed===>', event.value);

    console.log('this.compCopy====>', this.compCopy);


    if (!event.value.length) {
      this.compArray = this.compCopy;
    } else {
      let filterArray = [];
      this.compCopy.forEach((e1) => event.value.forEach((e2) => {
        if (e1.category == e2) {
          filterArray.push(e1)
        }
      }));
      this.compArray = filterArray;
    }
  }

  sortChanged(event) {
    console.log('Sort Changed===>', event.value);

    console.log('this.compArray In sort', this.compArray);

    if (event.value.type == 'asc') {
      this.compArray = sort_by_key(this.compArray, event.value.key);
    } else if (event.value.type == 'desc') {
      let tempArray = sort_by_key(this.compArray, event.value.key);
      this.compArray = tempArray.reverse();
    }

    function sort_by_key(array, key) {
      return array.sort(function (a, b) {
        let x = a[key]; let y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      });
    }
  }



  // Get competency List from google sheet
  getCompetencyList() {
    return new Promise((resolve, reject) => {
      this._competencyService.getCompetencyList().subscribe((data) => {
        console.log("LIST OF COMPETENCY", data)
        this.category = data
        resolve(this.category)
      }, error => {
        console.log("ERROR WHILE GET COMPETENCY LIST", error);

      })
    })
  }





  deleteFile(event) {
    console.log('delete Event:', event);
  }
  getRandomColorClass(i) {

    return this._utilityService.getCommonRandomColorClass(i)
    console.log("what is temp", i);
    // return temp
  }

  /**
   * Download trainig matrix sheet of all assigned competency to operative users
   */
  downloadTrainingMatrix() {
    this.isDisabled = true
    this._utilityService.handleSnackBar({ msg: 'Download will begin automatically', button: 'OK' })
    this._competencyService.downloadTrainingMatrix().subscribe((data) => {
      console.log("DOWNLOAD MATRIX FILE", data)
      if (data) {
        const downloadLink = document.createElement("a");
        downloadLink.href = data;
        downloadLink.download = 'trainingmatrixsheet'
        downloadLink.click();
        this.isDisabled = false
        this._utilityService.handleSnackBar({ msg: 'Download Successfully', button: 'OK' })
      }
    }, error => {
      console.log("ERROR WHILE DONWLOAD", error)
      this._utilityService.handleSnackBar({ msg: 'Issue while download trainig matrix', button: 'OK' })
      this.isDisabled = false
    })
  }

}
